import { axiosInstance } from "./axiosInstance";

/** `status` hanya membaca kuota di header, tanpa memakai jatah. */
export type CvBuilderAnalyzeBody = { resume: unknown } | { action: "export" | "status" };

/** Endpoint publik: kuota mengikuti JWT bila login, atau X-Guest-Id bila tamu. */
export const analyzeCvBuilder = async (body: CvBuilderAnalyzeBody, guestId?: string | null) => {
    return await axiosInstance.post(`/api/feature/cv-builder/analyze`, body, {
        headers: guestId ? { "X-Guest-Id": guestId } : undefined,
    });
};

/** Wajib login. Paket add-on CV Builder, tanpa biaya pendaftaran. */
export const getCvBuilderPackages = async () => {
    return await axiosInstance.get(`/api/feature/membership?filter[addon_type]=cv_builder`);
};
